import StorageGateway from 'lib/storage-gateway';
import { getCookie, clearCookie } from './cookieHelper';
import UserAPIGateway from 'accounts/gateways/user';

export const processBetaAuthToken = async (userAPIGateway) => {
  console.log('🔍 processBetaAuthToken: Starting beta token processing');

  // ENTERPRISE-GRADE: Check domain cookies first (production-ready approach)
  let betaToken = getCookie('betaToken');
  let betaAuthToken = getCookie('betaAuthToken');
  let betaCompanyId = getCookie('betaCompanyId');
  let betaUserId = getCookie('betaUserId');
  let betaJobTrackOrgId = getCookie('betaJobTrackOrgId');
  let betaJobTrackBearerToken = getCookie('betaJobTrackBearerToken');
  let betaGraniteToken = getCookie('betaGraniteToken');
  let beta_iframe_jwt_token = getCookie('beta_iframe_jwt_token');
  let profile = ""


  if (betaToken) {

    // Set token in beta's storage
    StorageGateway.set('Token', betaToken);

    if (betaAuthToken) {
      StorageGateway.set('oAuthToken', betaAuthToken);
    }

    // Create userAPIGateway instance for API calls
    const userAPIGateway = new UserAPIGateway();

    // Set company ID if provided (for super admin context)
    if (betaCompanyId) {
      StorageGateway.set('company_id', betaCompanyId);
      StorageGateway.set('nre_company_id', betaCompanyId);
    } else {
      profile = await this.userAPIGateway.getProfile();
      // Regenerate from profile if not in cookie
      StorageGateway.set("company_id", profile?.company?.id ?? "");
      StorageGateway.set("nre_company_id", profile?.company?.id ?? "");

    }

    // Handle Granite tokens
    if (betaGraniteToken && betaUserId) {
      StorageGateway.set('userId', betaUserId);
      StorageGateway.set('graniteToken', betaGraniteToken);

    } else {
      // Regenerate Granite tokens if missing
      try {
        if (userAPIGateway) {
          const graniteAccess = await userAPIGateway.getGraniteToken();
          if (graniteAccess) {
            betaUserId = graniteAccess?.user_id ?? null;
            betaGraniteToken = graniteAccess?.token ?? null;
            StorageGateway.set('userId', betaUserId);
            StorageGateway.set('graniteToken', betaGraniteToken);

          }
        }
      } catch (error) {
        console.error('❌ processBetaAuthToken: Failed to regenerate Granite tokens:', error);
      }
    }

    // Handle JobTrack tokens
    if (betaJobTrackOrgId && betaJobTrackBearerToken && beta_iframe_jwt_token) {
      StorageGateway.set('jobTrackOrgId', betaJobTrackOrgId);
      StorageGateway.set('JobTrackBearerToken', betaJobTrackBearerToken);
      StorageGateway.set('iframe_jwt_token', beta_iframe_jwt_token);

    } else {
      // Regenerate JobTrack tokens if missing (only for non-business admins)
      const isBusinessAdmin = profile?.is_business_admin;
      if (!isBusinessAdmin) {

        try {
          if (userAPIGateway) {
            const jobTrackAccess = await userAPIGateway.getJobTrackToken();
            if (jobTrackAccess) {
              betaJobTrackOrgId = jobTrackAccess?.organisation_id ?? null;
              betaJobTrackBearerToken = jobTrackAccess?.access_token ?? null;
              beta_iframe_jwt_token = jobTrackAccess?.jwt_token ?? null;

              StorageGateway.set('jobTrackOrgId', betaJobTrackOrgId);
              StorageGateway.set('JobTrackBearerToken', betaJobTrackBearerToken);
              StorageGateway.set('iframe_jwt_token', beta_iframe_jwt_token);
              StorageGateway.set('iframe_jwt_token_expiry', jobTrackAccess?.jwt_token_expiry ?? null);

            }
          }
        } catch (error) {
          if (error?.response?.status === 400) {
            console.error('❌ processBetaAuthToken: Bad Request while regenerating JobTrack tokens:', error.response?.data || error.message);
          } else {
            console.error('❌ processBetaAuthToken: Failed to regenerate JobTrack tokens:', error);
          }
        }
      }
    }

    // Set flag that user came from master
    StorageGateway.set('cameFromMaster', 'true');
    console.log("setting master flag true")
    // Clear the flag after 5 seconds
    setTimeout(() => {
      StorageGateway.remove('cameFromMaster');
    }, 5000);

    // Clear all cookies after use for security
    document.cookie = 'betaAuthToken=; domain=.worksana.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    document.cookie = 'betaCompanyId=; domain=.worksana.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    document.cookie = 'betaUserId=; domain=.worksana.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    document.cookie = 'betaJobTrackOrgId=; domain=.worksana.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    document.cookie = 'betaJobTrackBearerToken=; domain=.worksana.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    document.cookie = 'betaGraniteToken=; domain=.worksana.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    document.cookie = 'beta_iframe_jwt_token=; domain=.worksana.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    document.cookie = 'betaToken=; domain=.worksana.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    console.log('🧹 processBetaAuthToken: All domain cookies cleared for security');

    console.log('✅ processBetaAuthToken: Authentication and company context transferred successfully');
    return true;
  }

  console.log('❌ processBetaAuthToken: No domain cookie found, proceeding with normal authentication');
  return false;
};